// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__3ktkl","select":"Header_select__3TVut","clinic":"Header_clinic__2fkUu"};